const styles = () => ({
    headerDialog: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #ccc',
        paddingBottom: '10px',
        '& h5': {
            fontWeight: '400',
        },
        '& h6': {
            fontWeight: '400',
            fontSize: '.8rem',
        },
    },
});

export default styles;
